import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Mail, Phone, MapPin, Clock } from "lucide-react";

const ContactsPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1 max-w-4xl mx-auto px-4 py-8 w-full">
        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-8">Contatti</h1>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Email */}
          <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-green-500 p-3 rounded-lg">
                <Mail className="w-6 h-6 text-black" />
              </div>
              <h2 className="text-xl font-bold text-white">Email</h2>
            </div>
            <a 
              href="mailto:pregiatosrls@gmail.com" 
              className="text-green-500 hover:text-green-400 text-lg transition-colors"
            >
              pregiatosrls@gmail.com
            </a>
          </div>

          {/* Phone Roberto */}
          <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-yellow-500 p-3 rounded-lg">
                <Phone className="w-6 h-6 text-black" />
              </div>
              <h2 className="text-xl font-bold text-white">Roberto</h2>
            </div>
            <a 
              href="tel:+393928612924" 
              className="text-green-500 hover:text-green-400 text-lg transition-colors"
            >
              392 861 2924
            </a>
          </div>

          {/* Phone Angelo */}
          <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-yellow-500 p-3 rounded-lg">
                <Phone className="w-6 h-6 text-black" />
              </div>
              <h2 className="text-xl font-bold text-white">Angelo</h2>
            </div>
            <a 
              href="tel:+393342057548" 
              className="text-green-500 hover:text-green-400 text-lg transition-colors"
            >
              334 205 7548
            </a>
          </div>

          {/* Address */}
          <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-red-500 p-3 rounded-lg">
                <MapPin className="w-6 h-6 text-black" />
              </div>
              <h2 className="text-xl font-bold text-white">Sede</h2>
            </div>
            <p className="text-zinc-300">
              Via Dionigi della Torre 3<br />
              Frazione Tordandrea<br />
              06081 Assisi (PG)
            </p>
          </div>
        </div>

        {/* Company Info */}
        <div className="mt-8 bg-zinc-900 border border-zinc-800 rounded-lg p-6">
          <h2 className="text-xl font-bold text-white mb-4">Informazioni Aziendali</h2>
          <div className="grid sm:grid-cols-2 gap-4 text-zinc-300">
            <div>
              <p className="text-zinc-500 text-sm">Ragione Sociale</p>
              <p className="font-semibold text-white">PREGIATO SRLS</p>
            </div>
            <div>
              <p className="text-zinc-500 text-sm">Partita IVA</p>
              <p className="font-semibold text-white">03985760549</p>
            </div>
            <div>
              <p className="text-zinc-500 text-sm">PEC</p>
              <p className="text-green-500">pregiato@registerpec.it</p>
            </div>
            <div>
              <p className="text-zinc-500 text-sm">Forma Giuridica</p>
              <p>Società a responsabilità limitata semplificata</p>
            </div>
          </div>
        </div>

      </main>

      <Footer />
    </div>
  );
};

export default ContactsPage;
